import { createStore, combineReducers, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
// import { logger } from 'redux-logger';
import reducers from '../reducers';
// const middlewareList = [thunk, logger];
const middlewareList = [thunk];

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
let store = createStore(combineReducers(reducers), composeEnhancers(applyMiddleware(...middlewareList)));
export default store;



// WEBPACK FOOTER //
// ./src/App/redux/store/index.js